/* appStore.js — where JAI lives on the App Store.
   One place for the store identity so a link, a QR code, a Smart App Banner
   and any future marketing copy can't drift apart.

   APP_ID is Apple's own numeric id for the app (App Store Connect > the app >
   the number in the URL). The Smart App Banner in index.html hard-codes the
   same id because a meta tag can't import from JS — if this ever changes,
   change it there too. */

export const APP_STORE_APP_ID = '6808141951'

// Region-less link. Apple redirects the visitor to their own country's store,
// so this works for a US, AU or UK reader without us guessing which they are.
export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_APP_ID}`

// Live as of 9 September 2026. The EU is not included: Apple is still reviewing
// the Digital Services Act trader verification, which leaves 27 EU countries
// showing "Cannot Sell" until it clears. See OPS/COMMAND_CENTER.md.
export const APP_STORE_LIVE = true
